function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".launch_svg__cls-1{fill:#dbe0eb}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "launch_svg__Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "launch_svg__Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "launch_svg__cls-1",
  d: "M55 56H3a3 3 0 01-3-3V15a3 3 0 013-3h52a3 3 0 013 3v38a3 3 0 01-3 3zM6 50h46V18H6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "launch_svg__cls-1",
  d: "M70 48h-6V6H8.21V0H67a3 3 0 013 3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.72 36.42L31.08 25.86A3 3 0 0029 25a3 3 0 00-2.12.89l-10.6 10.64 4.26 4.22 5.46-5.5.07 20.75h6L32 35.22l5.51 5.46z",
  fill: "#3eb883"
})));

function SvgLaunch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.02 56.02"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3MC4wMiA1Ni4wMiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOiNkYmUwZWJ9PC9zdHlsZT48L2RlZnM+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik01NSA1NkgzYTMgMyAwIDAxLTMtM1YxNWEzIDMgMCAwMTMtM2g1MmEzIDMgMCAwMTMgM3YzOGEzIDMgMCAwMS0zIDN6TTYgNTBoNDZWMThINnoiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik03MCA0OGgtNlY2SDguMjFWMEg2N2EzIDMgMCAwMTMgM3oiLz48cGF0aCBkPSJNNDEuNzIgMzYuNDJMMzEuMDggMjUuODZBMyAzIDAgMDAyOSAyNWEzIDMgMCAwMC0yLjEyLjg5bC0xMC42IDEwLjY0IDQuMjYgNC4yMiA1LjQ2LTUuNS4wNyAyMC43NWg2TDMyIDM1LjIybDUuNTEgNS40NnoiIGZpbGw9IiMzZWI4ODMiLz48L2c+PC9nPjwvc3ZnPg==";
export { SvgLaunch as ReactComponent };